import React from 'react';
import Field from '../Field';
import { Form } from 'semantic-ui-react';
import airlineAnswerOptions from '../../options/airlineAnswerOptions';

const AirlineAnswerDropdown = ({ width, error, touched, name, label, value, onChange, onBlur, disabled }) => (
  <Field width={width} error={error} touched={touched}>
    <Form.Dropdown
      fluid
      label={label}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      options={airlineAnswerOptions}
      placeholder={label}
      search
      selection
      value={value}
      disabled={disabled}
    />
  </Field>
)

export { airlineAnswerOptions };
export default AirlineAnswerDropdown;



// WEBPACK FOOTER //
// ./src/component/dropdowns/AirlineAnswerDropdown.js